// ==============================|| OVERRIDES - DIALOG TITLE ||============================== //

import { Theme } from '@mui/material/styles';

export default function DialogContent(theme: Theme) {
  return {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.mode === 'dark' ? '#2A2D3C' : theme.palette.background.paper
        }
      }
    }
  };
}
